import React, { useEffect, useState } from 'react';
import { groupBy } from 'lodash';
import { useConsolidationScoreFaturamento } from '@/features/dashboard/api/getConsolidationScoreFaturamento.ts';
import LoadingChart from '@/features/dashboard/components/LoadingChart';
import ScoreInadimplenciaChartBarLine from './components/ScoreInadimplenciaChartBarLine';
import { useConsolidationDataDefault } from './api/getConsolidationDataDefault';
import { Alert, Button } from '@mui/material';

const ScoreInadimplenciaMenu = ({ year, month, setListYears }) => {
  const { data: defaultData, isError, refetch, isFetching, isFetched } = useConsolidationDataDefault(year);

  const { data: defaultDataYears } = useConsolidationDataDefault();


  const listYears = Object
  .keys(groupBy(defaultDataYears, 'ano'))
  .map((item) => Number(item))
  .sort((a, b) => b - a);


  const [yearLocal, setYearLocal] = useState<number | null>(null);

  useEffect(() => {
    if (isFetched) {
      const currentYear = new Date().getFullYear();
      const listYears = Object.keys(groupBy(defaultDataYears, 'ano'))
        .map((item) => Number(item))
        .sort((a, b) => b - a);
      setListYears(listYears);
      if (listYears.length) {
        setYearLocal(year === null ? currentYear : year);
      }
    }
  }, [isFetched, defaultData, year]);

  const monthOrder = {
    Jan: 1,
    Fev: 2,
    Mar: 3,
    Abr: 4,
    Mai: 5,
    Jun: 6,
    Jul: 7,
    Ago: 8,
    Set: 9,
    Out: 10,
    Nov: 11,
    Dez: 12,
  };
  
  const selectedData = defaultData?.find((item) => {
    if (String(item.ano) === String(year)) {
      item.valor_score_meses.sort((a, b) => monthOrder[a.nome] - monthOrder[b.nome]);
      return true;
    }
    return false;
  });
  
  return (
    <>
      <LoadingChart loading={isFetching} />
      {isError && (
        <Alert
          severity="error"
          action={
            <Button color="inherit" size="small" onClick={() => refetch()}>
              Atualizar
            </Button>
          }
        >
          Não foi possível carregar as informações!
        </Alert>
      )}

      {selectedData && !isFetching && (
        <ScoreInadimplenciaChartBarLine
          data={selectedData}
          color={'#E04A4C'}
          title={'Inadimplência por data de vencimento'}
          labelColor={'#000'}
        />
      )}
      
    </>
  );
};

export default ScoreInadimplenciaMenu;
